import { AssetRequestType } from "./constants";
import { createAsset } from "./createAsset";

export const createUploadAsset = (file: File, path: string, folderName?: string) => {
  return {
    ...createAsset(file.name, path),
    file,
    path,
    requestType: AssetRequestType.UPLOAD,
    folderName,
  };
};
